/**
 * Utilitaires purs pour la gestion des factures.
 * Aucune dépendance externe — facilement testables.
 */

// Sous-types billetterie reconnus
export const BILLETTERIE_NATURE_VALUES = ['BILLET_AVION', 'MODIFICATION', 'ASSURANCE', 'ATTESTATION', 'AUTRE'];

/**
 * Détermine le type_facture d'une facture à partir de ses données brutes API.
 * - Facture liée à un dossier → type du dossier en majuscules (ex: CIRCUIT, SEJOUR)
 * - Facture billetterie avec nature valide → nature en majuscules (ex: ASSURANCE)
 * - Facture billetterie sans nature reconnue → "BILLETTERIE"
 */
export const resolveTypeFacture = (facture) => {
    if (facture.dossier) {
        const dossierType = facture.dossier.type || '';
        return dossierType.toUpperCase() || 'PRODUCTION';
    }
    const nature = (facture.nature || '').toUpperCase();
    if (BILLETTERIE_NATURE_VALUES.includes(nature)) {
        return nature;
    }
    return 'BILLETTERIE';
};

/**
 * Filtre une liste de factures selon un type donné.
 * - 'ALL'         → toutes les factures
 * - 'BILLETTERIE' → type BILLETTERIE + tous les sous-types
 * - Sous-type     → uniquement les factures avec ce type exact
 */
export const filtrerParType = (factures, typeFilter) => {
    if (typeFilter === 'ALL') return factures;
    if (typeFilter === 'BILLETTERIE') {
        return factures.filter(f =>
            f.type_facture === 'BILLETTERIE' || BILLETTERIE_NATURE_VALUES.includes(f.type_facture)
        );
    }
    return factures.filter(f => f.type_facture === typeFilter);
};
